/* Lenora PDP helpers on Dawn: sticky add-to-cart, rewards box refresh, size-chart link keep-alive. */
(function () {
  if (window.__lnPdpInit) return;
  window.__lnPdpInit = true;

  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    var fmt = format || '${{amount}}';
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      if (key === 'amount_no_decimals') return Math.round(cents / 100).toString();
      if (key === 'amount_with_comma_separator') return value.replace('.', ',');
      return value;
    });
  }

  function initSticky(bar) {
    var sectionId = bar.dataset.sectionId;
    var mainBtn = document.getElementById('ProductSubmitButton-' + sectionId);
    if (!mainBtn) return;
    var variants = [];
    try { variants = JSON.parse(bar.querySelector('[data-sticky-atc-variants]').textContent); } catch (e) {}
    var idInput = bar.querySelector('[data-sticky-atc-id]');
    var priceEl = bar.querySelector('[data-sticky-atc-price]');
    var btn = bar.querySelector('[data-sticky-atc-btn]');
    var btnText = bar.querySelector('[data-sticky-atc-btn-text]');
    var img = bar.querySelector('[data-sticky-atc-image]');
    var selects = bar.querySelectorAll('[data-sticky-atc-option]');
    var moneyFormat = bar.dataset.moneyFormat;

    function render(variant) {
      if (!variant) {
        btn.disabled = true;
        btnText.textContent = bar.dataset.soldOutText;
        return;
      }
      idInput.value = variant.id;
      var html = '';
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        html += '<span class="sticky-atc__compare-price">' + formatMoney(variant.compare_at_price, moneyFormat) + '</span>';
      }
      html += '<span class="sticky-atc__current-price">' + formatMoney(variant.price, moneyFormat) + '</span>';
      priceEl.innerHTML = html;
      btn.disabled = !variant.available;
      btn.removeAttribute('aria-disabled');
      btnText.textContent = variant.available ? bar.dataset.addToCartText : bar.dataset.soldOutText;
      selects.forEach(function (sel) {
        var i = parseInt(sel.dataset.stickyAtcOption, 10);
        if (variant.options[i] !== undefined) sel.value = variant.options[i];
      });
      if (img && variant.featured_image && variant.featured_image.src) {
        var src = variant.featured_image.src;
        img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=88';
      }
    }

    selects.forEach(function (sel) {
      sel.addEventListener('change', function () {
        /* Block submit until Dawn resolves the new variant and render() sets its id. */
        btn.disabled = true;
        var picker = document.getElementById('variant-selects-' + sectionId);
        if (!picker) return;
        var name = sel.dataset.optionName;
        var inputs = picker.querySelectorAll('input[type="radio"], select option');
        for (var i = 0; i < inputs.length; i++) {
          var el = inputs[i];
          var elName = el.dataset.optionName;
          if (elName === name && el.value === sel.value) {
            if (el.tagName === 'OPTION') {
              el.parentElement.value = el.value;
              el.parentElement.dispatchEvent(new Event('change', { bubbles: true }));
            } else {
              el.checked = true;
              el.dispatchEvent(new Event('change', { bubbles: true }));
            }
            return;
          }
        }
      });
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        if (!event || !event.data || event.data.sectionId !== sectionId) return;
        var v = event.data.variant;
        var full = v && variants.find(function (x) { return x.id === v.id; });
        render(full || v);
      });
    }

    /* Show the bar once the main Add to cart button has scrolled above the viewport. A scroll
       listener, not only an IntersectionObserver: IO fires on intersection CHANGES, so a jump
       past the button (#reviews / #rewards-section links, fast flings, restored scroll) never
       fires it. The button is looked up each time because Dawn re-renders it on variant change. */
    var ticking = false;
    function update() {
      ticking = false;
      var el = document.getElementById('ProductSubmitButton-' + sectionId);
      var show = !!el && el.getBoundingClientRect().bottom < 0;
      if (bar.classList.contains('is-visible') === show) return;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      document.body.classList.toggle('ln-sticky-atc-visible', show);
    }
    function schedule() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    update();
  }

  function refreshRewards() {
    var box = document.querySelector('[data-rewards-pdp-box]');
    if (!box) return;
    var info = box.closest('product-info');
    var sectionId = info && info.dataset.section;
    if (!sectionId) return;
    fetch(window.location.pathname + '?section_id=' + encodeURIComponent(sectionId), { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var next = doc.querySelector('[data-rewards-pdp-box]');
        var live = document.querySelector('[data-rewards-pdp-box]');
        if (next && live) live.replaceWith(next);
      })
      .catch(function () {});
  }

  /* Storenaut size chart moves its opener into the Size legend. Dawn re-renders the picker on
     every variant change, which would drop the opener: keep a reference and put it back. */
  var snOpeners = [];
  document.addEventListener('change', function (e) {
    if (!e.target.closest || !e.target.closest('variant-selects')) return;
    snOpeners = Array.prototype.slice.call(document.querySelectorAll('.sn-size-chart[data-sn-moved] [data-sn-open], .sn-size-chart-inlabel [data-sn-open]'));
  }, true);
  function restoreSizeChart() {
    snOpeners.forEach(function (opener) {
      if (document.body.contains(opener)) return;
      var root = document.querySelector('.sn-size-chart[data-sn-moved]');
      var want = root ? (root.getAttribute('data-sn-option') || '').trim().toLowerCase() : '';
      if (!want) return;
      var legends = document.querySelectorAll('variant-selects legend');
      for (var i = 0; i < legends.length; i++) {
        var head = (legends[i].textContent || '').replace(/\s+/g, ' ').trim().toLowerCase().split(':')[0].trim();
        if (head === want) {
          legends[i].classList.add('sn-size-chart-inlabel');
          legends[i].appendChild(opener);
          break;
        }
      }
    });
  }

  function init() {
    document.querySelectorAll('[data-ln-sticky-atc]').forEach(initSticky);
    document.addEventListener('cart:updated', refreshRewards);
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(restoreSizeChart, 0); });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
